import React, { Fragment } from 'react';
import { cn } from '@/lib/utils';

export interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  okText?: string;
  type?: 'danger' | 'warning' | 'info' | 'success';
}

const toneClasses: Record<NonNullable<AlertModalProps['type']>, string> = {
  danger: 'text-red-600 dark:text-red-400',
  warning: 'text-amber-600 dark:text-amber-400',
  info: 'text-brand-600 dark:text-brand-400',
  success: 'text-emerald-600 dark:text-emerald-400',
};

export const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  okText = 'OK',
  type = 'info',
}) => {
  if (!isOpen) return null;

  return (
    <Fragment>
      <div className="fixed inset-0 z-40 bg-slate-900/50 dark:bg-slate-900/70" onClick={onClose} aria-hidden="true" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-xl dark:border-slate-700 dark:bg-slate-800">
          <div className="border-b border-slate-200 px-5 py-4 dark:border-slate-700">
            <h3 className={cn('text-base font-semibold', toneClasses[type])}>{title}</h3>
          </div>
          <div className="px-5 py-4">
            <p className="text-sm text-slate-600 dark:text-slate-300">{message}</p>
          </div>
          <div className="flex items-center justify-end border-t border-slate-200 px-5 py-3 dark:border-slate-700">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md bg-slate-700 px-3 py-1.5 text-sm font-medium text-white hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500"
            >
              {okText}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
